// Catálogo de papéis/Grupos de permissão (Administrator/Manager/Operator/
// Viewer + os criados manualmente pelo botão "Criar grupo") do GPS Drive
// Backend — usado pelo select "Grupo" na aba PRINCIPAL (Adicionar/Editar
// Usuário, pedido 2026-09-03: saiu da aba PERMISSÕES). O conjunto de
// permissões de cada Grupo (RoleDefaultPermission) é só um TEMPLATE —
// nunca lido para autorizar nada em tempo real, só copiado para o usuário
// quando o Grupo é selecionado (ver useChangeUserRole).
import { gpsDriveDelete, gpsDriveGet, gpsDrivePost, gpsDrivePut } from "@/lib/api/gpsdrive-client";
import type { PermissionCategoryState } from "./gpsdrive-user-permissions.service";

// "Gaveta" do Grupo — pedido 2026-09-03: "Grupo do usuário" (Admin/
// Usuário/Funcionário, ver gpsdrive-users.service.ts#AccountType) e
// "Grupo de permissão" (este tipo) viraram conceitos separados. "geral" =
// visível pra accountType admin/usuario; "funcionario" = só visível (e só
// criável) quando accountType do usuário é funcionario — os dois
// conjuntos nunca se misturam no mesmo select.
// "motorista" (2026-10-08): mesma ideia, gaveta só do Motorista.
export type RoleScope = "geral" | "funcionario" | "motorista";

export interface GpsDriveRole {
  id: string;
  name: string;
  scope: RoleScope;
}

export interface GpsDriveRoleDetail extends GpsDriveRole {
  permissions: PermissionCategoryState[];
}

export const gpsDriveRolesService = {
  list: () => gpsDriveGet<GpsDriveRole[]>("/api/v1/roles"),
  // Único jeito de ler o conteúdo (permissões) de um Grupo sem antes
  // aplicá-lo a um usuário real — usado para pré-preencher "Editar grupo".
  get: (id: string) => gpsDriveGet<GpsDriveRoleDetail>(`/api/v1/roles/${id}`),
  create: (name: string, scope: RoleScope, permissions: PermissionCategoryState[]) =>
    gpsDrivePost<GpsDriveRole>("/api/v1/roles", { name, scope, permissions }),
  // Grupo "Administrator" nunca pode ser editado/excluído — o backend
  // rejeita com 422 (ver RolesService#update/remove), aqui só repassamos.
  update: (id: string, name: string, scope: RoleScope, permissions: PermissionCategoryState[]) =>
    gpsDrivePut<GpsDriveRole>(`/api/v1/roles/${id}`, { name, scope, permissions }),
  remove: (id: string) => gpsDriveDelete<{ ok: boolean }>(`/api/v1/roles/${id}`),
};
